import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1kcui4ks: FaireBrandEntity = {
  token: "b_1kcui4ks",
  type: "brand",
  name: "MamaSuds | Non-toxic Household Cleaners + Real Soap",
  avatarUrl:
    "https://cdn.faire.com/fastly/6ebc410cff45d2eb3e0595bcf4b9275b88df526429a95dce75acb0ea5f7d51da.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/d0aafb325cb767104a9b9c8886df6391d15336241e5c66df5e214d78b1054c4a.png",
  logoUrl:
    "https://cdn.faire.com/fastly/6ebc410cff45d2eb3e0595bcf4b9275b88df526429a95dce75acb0ea5f7d51da.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d0aafb325cb767104a9b9c8886df6391d15336241e5c66df5e214d78b1054c4a.png",
  location: "Goodrich, MI, USA",
  minimumOrderDollars: 40,
  rating: 4.9,
  reviewCount: 259,
  isTopShop: true,
  isInsider: true,
  description:
    "MamaSuds is a company that produces small-batch, eco-friendly, non-toxic cleaning products. Our product line includes items like laundry soap, dish soap, and household cleaners that are made with safe, natural ingredients. We aim to provide effective cleaning solutions that are free from harmful chemicals, making them safe for families, pets, and the environment. We are particularly popular among label-reading moms with disposable income who prioritize natural and sustainable living.\n\n\n\nTHE MAMASUDS MANIFESTO\nI believe you can clean your home without damaging your health or our planet. I want you to live in a world where cleaning doesn't seem like a chore. I know that the wellness you find beneath your kitchen sink and on your bathroom counter is equally as important as the food you put on your table. I refuse to put profits over people or planet. You, your family, and this planet depend on us to make health a priority. I invite you to join my movement of passionately smart women who want to know more to do better.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:43:58.918Z",
    importedBy: "entity-db-cli",
  },
};
